export default "__VITE_ASSET__21714aba__"